module.exports = __webpack_public_path__ + "img/mode-espece.73397a17.png";